<template>
  <form class="u-space u-space--large" @submit.prevent="submit">
    <div>
      <div class="u-scroller u-space--h u-space--large">
        <button
          v-for="card in cardsOneCanLay"
          :key="card.index"
          :class="`card card--${card.name.toLowerCase()}`"
          type="button"
          :disabled="card.disabled"
          @click="pickCard(card.index)"
        >({{ card.count }})</button>
      </div>
    </div>

    <footer class="u-split">
      <div class="u-flex u-space--h u-align-center">
        <input type="submit" class="button button--green" value="Lay cards" :disabled="!timeToLay" />
        <span v-if="timeToLay">Laying {{ laying }} card{{ laying === 1 ? "" : "s" }}</span>
      </div>

      <div>
        <strong>Remaining trains</strong>
        <div class="u-space--h">
          <small
            v-for="player in syncedState.players"
            :key="player.id"
            :class="`player-name player-name--${player.colour}`"
          >
            <span>{{ player.name }}:</span>
            <strong>{{ totalTrains - player.laid }}</strong>
          </small>
        </div>
      </div>

      <div class="u-flex u-space--h u-align-center">
        <input type="button" class="button" value="Reset" :disabled="!timeToLay" @click="reset" />
        <input
          type="button"
          class="button"
          value="Cancel"
          :disabled="!timeToLay"
          @click="$store.commit('setStatus', 'waiting')"
        />
      </div>
    </footer>
  </form>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      cardsToLay: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0 }
    };
  },

  computed: {
    ...mapState(["syncedState", "status", "totalTrains", "cardNames"]),
    ...mapGetters(["you", "yourGo"]),

    timeToLay() {
      return this.yourGo && this.status === "laying";
    },

    laying() {
      return Object.values(this.cardsToLay).reduce((a, b) => a + b, 0);
    },

    keyYouCanPick() {
      const key = Object.values(this.cardsToLay)
        .map((value, index) => {
          if (value && index !== 0) return index;
          else return null;
        })
        .filter(Boolean);

      return key[0];
    },

    cardsOneCanLay() {
      const keyToPick = this.keyYouCanPick;

      return this.cardNames.map((name, index) => {
        const count = this.you.cards[index] - this.cardsToLay[index];
        let disabled = count <= 0;

        if (!disabled && keyToPick && index !== 0) {
          disabled = index !== keyToPick;
        }

        if (this.laying >= 6) {
          disabled = true;
        }

        if (["finishing", "cards", "journeys"].includes(this.status)) {
          disabled = true;
        }

        return {
          name,
          index,
          count,
          disabled
        };
      });
    }
  },

  methods: {
    pickCard(index) {
      if (!this.yourGo) return;

      this.cardsToLay[index]++;
      this.$store.commit("setStatus", "laying");
    },

    reset() {
      this.$store.commit("setStatus", "waiting");
      Object.keys(this.cardsToLay).forEach(key => {
        this.cardsToLay[key] = 0;
      });
    },

    submit() {
      const laying = this.laying;

      Object.keys(this.cardsToLay).forEach(key => {
        for (let index = 0; index < this.cardsToLay[key]; index++) {
          this.$store.commit("layCard", Number(key));
        }
      });

      this.$store.commit("laidCards", laying);

      this.reset();
      this.$store.commit("setStatus", "finishing");
    }
  }
};
</script>
